import React from "react";

const Counter = (p) => {
  const [store] = [p.store];

  return (
    store && store.viewCounter ? 
      <div className="counter">
        {store.viewCounter}
      </div> : null
    
  )
}

export default Counter;